import { clsx } from 'clsx';

import { Banner, type BannerProps } from './banner';
import { Carousel, type CarouselProps } from './carousel';
import { HeroFallback } from './hero-fallback';

export interface HeroProps extends CarouselProps {
  slides?: BannerProps[];
  autoPlay?: boolean;
  speed?: number;
  parallaxSpeed?: BannerProps['parallaxSpeed'];
  layout?: BannerProps['layout'];
  contentAlignment?: BannerProps['contentAlignment'];
  ratio?: BannerProps['ratio'];
  id?: string;
}

export function Hero({
  id,
  slides,
  autoPlay,
  speed,
  className,

  // banner props to be passed through
  parallaxSpeed,
  contentAlignment,
  ratio,
  layout,
  ...rest
}: HeroProps) {
  if (!slides?.length) return <HeroFallback />;

  const bannerProps = {
    id,
    parallaxSpeed,
    contentAlignment,
    ratio,
    layout,
    className: clsx(layout === 'padded' && 'overflow-clip rounded'),
  };

  if (slides?.length === 1) {
    const slide = slides[0];

    // pass the className through here but not in the carousel as it's being passed in at the root
    return <Banner {...slide} {...bannerProps} className={className} />;
  }

  return (
    <Carousel
      className={clsx('text-white', className)}
      classNames={{
        carouselItem: 'pl-0 sm:pl-0',
        carouselContent: 'ml-0 sm:ml-0',
        pagination: clsx('max-w-(--breakpoint-xl)', {
          '[&>div]:justify-end': contentAlignment?.alignment?.horizontalAlignment === 'right',
          '[&>div]:justify-start': contentAlignment?.alignment?.horizontalAlignment === 'left',
        }),
      }}
      hideButtons={
        contentAlignment?.alignment?.horizontalAlignment && contentAlignment.alignment.horizontalAlignment !== 'center'
      }
      autoPlayDuration={autoPlay ? speed : undefined}
      items={slides?.map((slide, i) => (
        <Banner key={slide.heading || '' + i} {...slide} {...bannerProps} />
      ))}
      {...rest}
    />
  );
}
